import {useContext} from 'react'
import Modal, {ModalBody, ModalHeader} from '../../../common/Modal'
import {PromotedBranchContext} from '../../context/context'
import Button from '../../../common/Button'
import CheckBox from '../../../common/CheckBox'
import {NavContext} from '../../../../context/global_context'
import {useNavigate, useParams} from 'react-router-dom'
import {postRequest} from '../../../../services/base'
import {formatDateTime} from '../../../../utils/common'

const SelectTrashFilesModal = ({
  showTrashedModal,
  setShowTrashedModal,
  selectedTrashFiles,
  setSelectedTrashFiles,
  getMakeModalFileDetails,
}) => {
  const [state, dispatch] = useContext(PromotedBranchContext)
  const { vehicle, branch } = useParams()
  const navigate = useNavigate()

  const [navState, navDispatch] = useContext(NavContext)

  const selectUnSelectFiles = (trash_id) => {
    if (selectedTrashFiles.includes(trash_id)) {
      let tempIndex = selectedTrashFiles?.indexOf(trash_id)
      let tempSelectedFiles = [...selectedTrashFiles]
      tempSelectedFiles.splice(tempIndex, 1)
      setSelectedTrashFiles([...tempSelectedFiles])
    } else {
      let tempSelectedFiles = [...selectedTrashFiles]
      tempSelectedFiles.push(trash_id)
      setSelectedTrashFiles(tempSelectedFiles)
    }
  }

  const deleteSelectedTrashedFiles = async () => {
    if (
      window.confirm(
        `Are you sure want to delete selected files also make sure newly promoted files not included in this list, after this you can't rollback it.`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Selected Files ...',
          showLoader: true,
        },
        notification: {},
      })

      let payload = {
        trashed_files: selectedTrashFiles,
      }
      let res = await postRequest(
        `/api/delete/promoted-files/trash/delete/${vehicle}/`,
        payload
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Files Successfully Deleted',
          },
        })
        getMakeModalFileDetails()
        setShowTrashedModal(false)
        setTimeout(() => {
          navigate('/manage-update-list')
        }, 1000)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.data?.msg,
          },
        })
        setShowTrashedModal(false)
      }
    }
  }

  return (
    <Modal
      onClose={() => {
        setShowTrashedModal(false)
        setSelectedTrashFiles([])
      }}
      show={showTrashedModal}
      size={`w-full`}
    >
      <ModalHeader className={'text-white'}>
        <div className="flex items-center text-base justify-between">
          <div className="w-full">
            Select trashed files to delete from promoted branch
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-row flex-wrap text-white text-lg w-full">
          {state?.selectedFiles?.trash_files?.map(
            (trash_file, trashFileIdx) => {
              return (
                <div
                  className="flex flex-wrap"
                  key={`trash-file-${trashFileIdx}`}
                >
                  <div className={`px-2 flex w-full items-center`}>
                    <CheckBox
                      onChange={(e) => {
                        selectUnSelectFiles(trash_file.id)
                      }}
                      checked={selectedTrashFiles?.includes(trash_file.id)}
                    />
                    <div className="px-2 leading-5">
                      <div>{trash_file.name}</div>
                      <div className="flex gap-2">
                        <span className="font-semibold">
                          {trash_file.model_name}
                        </span>
                        <span className="text-sm">
                          ({formatDateTime(trash_file.created_at)})
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          )}
        </div>
        {selectedTrashFiles?.length > 0 && (
          <div className="flex flex-row pt-4 items-center justify-end">
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              text={`Delete Selected Trashed Files`}
              onClick={() => {
                deleteSelectedTrashedFiles()
              }}
            />
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default SelectTrashFilesModal
